import React, {useEffect, useContext} from 'react'
import {AutoComplete, Form} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";
import { getStockById } from '../../../services/serviceStock';

const {Option} = AutoComplete

const PurchaseStock = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {stocks, purchaseItems} = useContext(PurchaseContext)
    const [stockList] = stocks
    const [purchaseItemList, setPurchaseItemList] = purchaseItems
    const stockOptions = record.lock ? [] : stockList;

    useEffect(() => {
        if (record.stock) {
            const matchedStock = stockList.find(item => Number(item.value) === Number(record.stock))
            if (matchedStock) {
                form.setFieldsValue({
                    [`purchase-stock-${record.key}`]: matchedStock.text
                })
            }
        }
    }, [stockList, record.stock])

    const handleStockChange = (v, {key}) => {
        if (key) {
            getStockById(key)
                .then(({data}) => {
                    if (data) {
                        const newList = replaceIndexAt(
                            purchaseItemList,
                            {
                                ...purchaseItemList[rowIndex],
                                stock: key,
                                unitPrice: data.price,
                                unit: data.unit,
                                selectedCurrency: data.currency,
                                contentId: data.contentId
                            },
                            rowIndex
                        )
                        setPurchaseItemList(newList)
                    }
                })
        }
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    style={{marginBottom: 0, minWidth: '30vw'}}
                    name={`purchase-stock-${record.key}`}
                >
                    <AutoComplete
                        style={{minWidth: '100%'}}
                        key={`purchase-stock-${record.key}`}
                        className={'purchase-table-stock'}
                        filterOption={(inputValue, option) =>
                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                        onChange={handleStockChange}
                    >
                        {
                            stockOptions.map(item => (
                                <Option key={item.value} value={item.text}>{item.text}</Option>
                            ))
                        }
                    </AutoComplete>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseStock